// extracted by mini-css-extract-plugin
export default {"paymentPerMonthCard":"PaymentPerMonthCard_paymentPerMonthCard__9VGkh","infoLine":"PaymentPerMonthCard_infoLine__yyoCA"};